module.exports = __webpack_public_path__ + "img/logo-text2.48abdbb2.png";